import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { BaseButtonComponent } from '../base-button/base-button.component';

@Component({
  standalone: true,
  selector: 'rounded-button',
  imports: [NgTemplateOutlet],
  template: `
    @if (hasRootTemplate()) {
    <span (click)="onClick($event)">
      <ng-container *ngTemplateOutlet="buttonContent?.tpl; context: { $implicit: context }"></ng-container>
    </span>
    } @else {
    <button mat-button (click)="onClick($event)" type="button">
      <ng-container *ngTemplateOutlet="buttonContent?.tpl; context: { $implicit: context }"></ng-container>
    </button>
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'button--rounded'
  },
  exportAs: 'roundedButton'
})
export class RoundedButtonComponent extends BaseButtonComponent {
  constructor() {
    super();
  }

  onClick(event: MouseEvent | TouchEvent) {
    if (!this.hasRootTemplate()) {
      event.preventDefault();
      event.stopPropagation();
      this.click.emit({ event: event, context: this.context });
      this.changeDetector.markForCheck();
    }
  }
}
